<template>
  <div class="index">
    <van-nav-bar title="填写调研问卷" fixed left-arrow @click-left="$router.push('/homeTopic')" />
    <div class="index-head">
      <img src="@/assets/image/survey/head-bgc.png">
    </div>

    <div class="box">
      <div class="box-con">
        <!-- 1 -->
        <div class="box-item">
          <div class="box-left">
            <div class="box-left-title">淋巴瘤诊疗观念调研1</div>
            <div class="box-left-text">
              说明：按序参与调研，每位用户每月仅限参与一次
              <span v-if="list1.view_status == 1" style="color:blue;margin-left: 5px;cursor: pointer;"
                @click="gotomy()">(前往个人中心查看)</span>
            </div>
            <el-button v-if="list1.open_status == 1" type="primary" size="small"
              @click="fillinvestigate1">填写问卷</el-button>
          </div>
          <div class="box-right">
            <img v-if="list1.status == 1" src="@/assets/image/survey/1.png">
            <img v-if="list1.status == 0" src="@/assets/image/survey/2.png">
            <img v-if="list1.status == -1" src="@/assets/image/survey/3.png">
          </div>
        </div>

        <!-- 2 -->
        <div class="box-item">
          <div class="box-left">
            <div class="box-left-title">淋巴瘤诊疗观念调研2</div>
            <div class="box-left-text">
              说明：按序参与调研，每位用户每月仅限参与一次
              <span v-if="list2.view_status == 1" style="color:blue;margin-left: 5px;cursor: pointer;"
                @click="gotomy()">(前往个人中心查看)</span>
            </div>
            <el-button v-if="list2.open_status == 1" type="primary" size="small"
              @click="fillinvestigate2">填写问卷</el-button>
          </div>
          <div class="box-right">
            <img v-if="list2.status == 1" src="@/assets/image/survey/1.png">
            <img v-if="list2.status == 0" src="@/assets/image/survey/2.png">
            <img v-if="list2.status == -1" src="@/assets/image/survey/3.png">
          </div>
        </div>

        <!-- 3 -->
        <div class="box-item">
          <div class="box-left">
            <div class="box-left-title">淋巴瘤诊疗观念调研3</div>
            <div class="box-left-text">
              说明：按序参与调研，每位用户每月仅限参与一次
              <span v-if="list3.view_status == 1" style="color:blue;margin-left: 5px;cursor: pointer;"
                @click="gotomy()">(前往个人中心查看)</span>
            </div>
            <el-button v-if="list3.open_status == 1" type="primary" size="small"
              @click="fillinvestigate3">填写问卷</el-button>
          </div>
          <div class="box-right">
            <img v-if="list3.status == 1" src="@/assets/image/survey/1.png">
            <img v-if="list3.status == 0" src="@/assets/image/survey/2.png">
            <img v-if="list3.status == -1" src="@/assets/image/survey/3.png">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>  
<script>
export default {
  name: 'survey',
  data() {
    return {
      list1: {},
      list2: {},
      list3: {},
    }
  },
  created() {
    this.getswitchinfoList()
  },
  methods: {
    fillinvestigate1() { this.$router.push({ path: '/survey1', query: { id: this.list1.id } }) },
    fillinvestigate2() { this.$router.push({ path: '/survey2', query: { id: this.list2.id } }) },
    fillinvestigate3() { this.$router.push({ path: '/survey3', query: { id: this.list3.id } }) },
    viewfillinvestigate1() { this.$router.push({ path: '/surveydel1', query: { id: this.list1.id } }) },
    viewfillinvestigate2() { this.$router.push({ path: '/surveydel2', query: { id: this.list2.id } }) },
    viewfillinvestigate3() { this.$router.push({ path: '/surveydel3', query: { id: this.list3.id } }) },
    //列表
    async getswitchinfoList() {
      const { data: data } = await this.$http.get("/survey/switch-info");
      this.list1 = data.data[0]
      this.list2 = data.data[1]
      this.list3 = data.data[2]
    },
    //前往个人中心 
    gotomy() {
      this.$router.push({ path: '/my/diao' })
    },
  }
}  
</script>
<style scoped> .index {
   position: relative;
   width: 100%;
 }

 .index-head {
   position: absolute;
   top: 0;
   left: -15px;
   width: 108.8%;
   height: 96px;
 }

 .box {
   position: relative;
   top: 30px;
   left: -15px;
   width: 108.8%;
   background-color: #F6F8FF;
   border-radius: 15px 15px 0px 0px;
   box-shadow: 0px 0px 6px 1px #A4C4F1;
   height: calc(100vh - 76px);
   padding: 20px 15px;
 }

 .box-con {
   padding: 12px;
   background-color: #fff;
   border-radius: 6px;
   height: 100%;
 }

 .box-item {
   position: relative;
   width: 321px;
   height: 141px;
   background: url(@/assets/image/survey/item.png) no-repeat center 0px;
   background-position: center 0px;
   background-size: cover;
   margin-bottom: 14px;
 }

 .box-item:last-child {
   margin-bottom: 0;
 }

 .box-left {
   padding: 24px 0 0 10px;
 }

 .box-left-title {
   color: #2B2B2B;
   font-size: 15px;
   margin-bottom: 5px;
 }

 .box-left-text {
   color: #6B6F97;
   font-size: 13px;
   width: 220px;
   margin-bottom: 15px;
 }

 .box-right {
   position: absolute;
   top: 10px;
   right: 13px;
   width: 66px;
   height: 30px;
 }
</style>     